import { render, staticRenderFns } from "./Fiscal.vue?vue&type=template&id=556ed214&scoped=true"
import script from "./Fiscal.vue?vue&type=script&lang=js"
export * from "./Fiscal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556ed214",
  null
  
)

export default component.exports